.container {
  position: relative;
  margin-top: 3px;
  transition:
    transform 250ms cubic-bezier(0.1, 0, 0, 1),
    box-shadow 250ms ease-out,
    background-color 250ms ease-out;
  /* hack to prevent pixel shift on hover */
  backface-visibility: hidden;
  transform: translateZ(0) scale(1, 1);
}

.rounded {
  border-radius: var(--rds-roundness--image);
  overflow: hidden;
}

.circle {
  border-radius: 100%;
  overflow: hidden;
}

.container > *:first-child {
  @media (hover: hover) {
    &::after {
      content: ' ';
      inset: 0;
      position: absolute;
      transition: transform 250ms cubic-bezier(0.1, 0, 0, 1);
      opacity: 0;
    }
  }
}

.rounded > *:first-child {
  @media (hover: hover) {
    &::after {
      border-radius: var(--rds-roundness--image);
    }
  }
}
